import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { useGetHasCreatedObjectQuery } from '../../../__generated__/chirp/com/hubspot/growth/usage/rpc/GrowthUsageChirpService.hooks';
const EMPTY_STATE_ELIGIBLE_OBJECT_TYPES = ['COMPANY', 'DEAL', 'CONTACT'];
export const useHasCreatedObject = objectType => {
  const objectTypeId = ObjectTypesToIds[objectType];
  const _useGetHasCreatedObje = useGetHasCreatedObjectQuery({
      variables: {
        objectTypeId
      },
      skip: !EMPTY_STATE_ELIGIBLE_OBJECT_TYPES.includes(objectType)
    }),
    {
      data
    } = _useGetHasCreatedObje,
    rest = _objectWithoutPropertiesLoose(_useGetHasCreatedObje, _excluded);
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.hasCreated
  }, rest);
};